import { Injectable, Optional } from '@angular/core';

export class IconServiceConfig {
    symbolDefPath = '';
}

@Injectable()
export class IconService {
    symbolDefPath = '';

    constructor(@Optional() config: IconServiceConfig) {
        if (config) {
            this.symbolDefPath = config.symbolDefPath;
        }
    }
}
